<template>

    <Head>
        <meta name="title" content="5000 İngilizce Kelime A-Z | PDF + Quiz + Telaffuzlar + Örnek Cümle" />
        <title>5000 İngilizce Kelime A-Z | PDF + Quiz + Telaffuzlar + Örnek Cümle</title>
        <meta name="description"
            content="En çok kullanılan 5000 İngilizce kelime aşağıda listelenmiştir. Bu kelimelere buradan Quiz eşliğinde çalışabilirsiniz. Örnek cümle içinde kullanım, telaffuz ve PDF dosyası eklendi." />
    </Head>
    <div class="container pt-5 mt-5 pb-3">

        <div class="row mx-auto">
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
            <div class="col-12 col-md-8 mx-auto">
                <h1 class="archivo">5000 İngilizce Kelime A-Z | PDF + Quiz + Telaffuzlar + Örnek Cümle</h1>

                <p class="mt-5">En çok kullanılan İngilizce kelimeleri öğrenmenin birçok avantajı vardır. İş veya okul
                    hayatınızda
                    size yeni kapılar açar. Bu kelimeleri
                    öğrendiğinizde dizi ve filmleri rahatlıkla ingilizce altyazılı veya altyazısız anlayabilecek konuma
                    gelebilirsiniz. Ayrıca aşağıdaki kelime listesi <b>günlük dilde en çok kullanılan kelimeler</b>
                    olduğu için bu kelimeleri öğrenmek ingilizce konuşma yeteneğinizi de geliştirecektir. 69 dizi ve 47
                    film tarayarak <b>en çok kullanılan 5000 İngilizce kelimeyi</b> belirledik. Aşağıdaki listede her
                    kelime
                    anlamıyla birlikte A'dan Z'ye sıralanmıştır. Kelimelerin üstüne tıklayarak <b>örnek cümle içinde
                        kullanımını</b> görebilirsiniz. Ek olarak kelimenin solunda bulunan ses ikonuna tıklayarak
                    <b>kelimenin
                        İngilizce telaffuzunu da dinleme şansınız var.</b>
                </p>

                <h2>Bu Kelime Listesi Nasıl Oluşturuldu? </h2>
                <br>
                <p>Diziyle Öğren tarafından geliştirilen özel <b>Yapay zeka yazılımı ve doğal dil işleme motoru</b>
                    İngilizce
                    dilinde
                    çekilmiş olan dizi ve filmleri tarayarak <b>en sık kullanılan kelime ve kalıpları otomatik olarak
                        belirlemektedir.</b> Geliştirdiğimiz algoritma bu kelimelere zorluk ataması da yapabilecek
                    yetkinliğe
                    sahiptir. Yazılımımız yeni dizi ve film taradıkça <b>aşağıdaki listenin değişebileceğini
                        belirtmeliyiz.</b>
                    Yakın zamanda yeni kelime listeleri yayınlayacağız. Blog
                    yazısı yayınlandığında haberdar olmak için bizi <a href="https://www.instagram.com/diziyleogren/"
                        target="_blank">sosyal medya</a> hesaplarımızdan takip edebilirsiniz.
                </p>

                <div v-if="false" class="ad-container-yatay">
                    <Adsense data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990" data-ad-format="auto"
                        :data-full-width-responsive="true">
                    </Adsense>
                </div>

                <h2> En Çok Kullanılan 5000 İngilizce Kelime PDF
                </h2>
                <p class="mt-4"> <b>Kelimeleri çıktı alıp çalışmak istiyorsanız
                        PDF
                        dosyasını aşağıdan indirebilirsiniz.</b>
                    PDF dosyasına sadece Premium üyelerimiz erişebilir. Sınırsız PDF indirme avantajının yanında Premium
                    üyelik ile dizilerde kullanılan kelimelere ve özel içeriklere de erişebilirsiniz. Sizler için bu
                    tür özel listeler hazırlamaya devam edeceğiz 😊</p>

                <div class="primary-container">
                    <h3 class="title">5000 İngilizce Kelime Listesi.pdf</h3>
                    <router-link v-if="isPremium" to="/premium/5000-kelime-listesi-pdf">
                        <button class="download-button" data="İNDİR">İNDİR</button>
                    </router-link>
                    <template v-else>
                        <router-link :to="{ path: $store.getters.getLocaleLink('/premium') }"
                            class="text-decoration-none">
                            <button class="upgrade-button" data="Yükselt">PREMİUM</button>
                        </router-link>
                        <small>Sınırsız PDF indirme hakkı ve Premium üyelik sadece 59.99 TL!
                        </small>
                    </template>

                </div>

                <div class="row mt-5">
                    <WordListComponent v-if="isReady" :wordList="wordListData.words" :sliderValueArg="[1, 9]">
                    </WordListComponent>
                    <Loading style="" v-else />
                </div>
                <div v-if="list_index < 5" class="row mt-5 mx-auto">
                    <div class="col-4 mx-auto">
                        <button @click="load_words()" class="medium-purple-button">DEVAMINI GÖR</button>
                    </div>
                </div>
            </div>
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
        </div>
        <SuggestedBlogs></SuggestedBlogs>
    </div>
</template>
<script>
import axios from "axios"
import WordListComponent from "../../../components/Shared/WordListComponent.vue";
import SuggestedBlogs from "../../../components/Shared/SuggestedBlogs.vue";
export default {
    data() {
        return {
            wordListData: {},
            isReady: false,
            list_index: 1,
            list_ids: [943, 945, 946, 947, 948]
        };
    },
    components: {
        WordListComponent,
        SuggestedBlogs
    },
    created() {
        this.$store.commit('setEditOption', false)

        axios.get('/api/WordList/GetWordListV2', { params: { type: 5, id: 943, MeanLanguageType: 2 } }).then((response) => {
            this.wordListData = response.data

        }).finally(() => {
            this.isReady = true
        }).catch(error => {
            console.log(error.response.data)
        })
    },
    methods: {
        load_words() {
            if (this.list_index < 5) {
                axios.get('/api/WordList/GetWordListV2', { params: { type: 5, id: this.list_ids[this.list_index], MeanLanguageType: 2 } }).then((response) => {
                    let words = response.data.words
                    this.wordListData.words.push(...words)
                }).finally(() => {
                    this.isReady = true
                    this.list_index += 1
                }).catch(error => {
                    console.log(error.response.data)
                })
            }
        }
    },
    computed: {
        isPremium() {
            return this.$store.getters.getUserData.isPremium
        }
    }
}

</script>
<style scoped>
.primary-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
    border-radius: 16px;
    background-color: #FBFBFB;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);
    padding: 16px;
    width: 95%;
    max-width: 960px;
}

.title {
    color: var(--Primary, #8887C6);
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.upgrade-button {
    width: 144px;
    height: 48px;
    background-color: #B26C6C;
    transition: background-color 0.5s;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.download-button {
    width: 144px;
    height: 48px;
    color: var(--Lightest-Gray, #FBFBFB);
    background-color: var(--Green---Success, #9CD189);
    transition: background-color 0.5s;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.upgrade-button:hover {
    background-color: #b36060;
}

.download-button:hover {
    background-color: #83c969;
}
</style>